import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const AUTHORIZERS = new InjectionToken<Authorizer[]>('Authorizers');

export interface Authorizer {
  readonly isAuthorizedChanges: Observable<boolean>;
  readonly order: number;
  readonly toggleActive?: (isActive: boolean) => void;
}
